import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Currency, DropDownEntity } from '../models/drop-down-entity';

@Injectable({
  providedIn: 'root'
})
export class DropDownService {

  apiUrl = environment.champsApiUrl;
  constructor(private http: HttpClient) { }

  getUserBaselines(userId: string): Observable<any> {
    const params = new HttpParams()
      .set('userId', `${userId}`);
    return this.http.get<any>(`${this.apiUrl}/dropdown/BaseLine`, { params });
  }

  getSimulationsByBaseline(baselineId: number): Observable<any> {
    const params = new HttpParams()
      .set('baselineId', `${baselineId}`);
    return this.http.get<any>(`${this.apiUrl}/dropdown/Simulation`, { params });
  }

  getChannelsByBaseline(baselineId: number): Observable<DropDownEntity[]> {
    const params = new HttpParams()
      .set('baselineId', `${baselineId}`);
    return this.http.get<DropDownEntity[]>(`${this.apiUrl}/DropDown/Channel`, { params });
  }

  getBrandsByBaseline(baselineId: number): Observable<any> {
    const params = new HttpParams()
      .set('baselineId', `${baselineId}`);
    return this.http.get<any>(`${this.apiUrl}/dropdown/Brand`, { params });
  }

  getPacksByBaseline(baselineId: number): Observable<any> {
    const params = new HttpParams()
      .set('baselineId', `${baselineId}`);
    return this.http.get<any>(`${this.apiUrl}/dropdown/Pack`, { params });
  }

  getIsscom(isscomType: string): Observable<any> {
    const params = new HttpParams()
      .set('isscomType', isscomType);
    return this.http.get<any>(`${this.apiUrl}/dropdown/Isscom`, { params });
  }

  getTypeMaster(typeName: string): Observable<DropDownEntity[]> {
    const params = new HttpParams()
      .set('typeName', typeName);
    return this.http.get<DropDownEntity[]>(`${this.apiUrl}/DropDown/OtherMaster`, { params });
  }

  getCurrencyList(currencyCode?: string): Observable<Currency[]> {
    const params = new HttpParams()
      .set('currencyName', `${currencyCode}`);
    return this.http.get<Currency[]>(`${this.apiUrl}/DropDown/Currency`, { params });
  }

  getAssetsByBaseline(baselineId: number): Observable<DropDownEntity[]> {
    const params = new HttpParams()
      .set('baselineId', `${baselineId}`);
    return this.http.get<DropDownEntity[]>(`${this.apiUrl}/DropDown/Assets`, { params });
  }
  getbaseLineByuserId(userId: string): Observable<DropDownEntity[]> {
    const params = new HttpParams()
      .set('userId', `${userId}`);
    return this.http.get<DropDownEntity[]>(`${this.apiUrl}/DropDown/BaseLine`, { params });
  }
}